import { useStyles, Caption } from '@archipro-design/aria';
import type { AwardInfo } from '~/modules/professional/api/info-page-loader.server';

import * as S from './Awards.style';
import { Link } from '@remix-run/react';

export const AwardRowFullMobile: React.FC<AwardInfo> = ({
    YearAwarded,
    AwardingInstitutionTitle,
    Title,
    AwardedEntities,
}) => {
    const { css } = useStyles();
    return (
        <div className={css(S.AwardContainerMobile)}>
            {YearAwarded ?? (
                <Caption variant="03" className={css(S.RowAwardName)}>
                    {YearAwarded}
                </Caption>
            )}
            <Caption variant="03" className={css(S.RowAwardName)}>
                {Title}
            </Caption>
            <Caption variant="03" className={css(S.RowOrgName)}>
                {AwardingInstitutionTitle}
            </Caption>
            <Caption variant="03" className={css(S.RowOrgName)}>
                {AwardedEntities.map((a, i) => (
                    <Link
                        className={css(S.DirectoryItemLink)}
                        key={i}
                        to={a.link}
                    >
                        <span className={css(S.UnderlinedLinkTitle)}>
                            {a.title || a.label}
                        </span>
                    </Link>
                ))}
            </Caption>
        </div>
    );
};
